var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavShortForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7488 32.7648L32.4384 30.0528L27.7488 27.3408V32.76V32.7648ZM39.936 30.0528L24 39.2592V20.8416L39.936 30.048V30.0528ZM54 30C54 36.4128 51.504 42.4368 46.9728 46.9728C42.4416 51.504 36.4128 54 30 54C23.5872 54 17.5632 51.504 13.0272 46.9728C8.49601 42.4416 6 36.4128 6 30H9.7488C9.7488 41.1648 18.8352 50.2512 30 50.2512C41.1648 50.2512 50.2512 41.1648 50.2512 30C50.2512 18.8352 41.1648 9.7488 30 9.7488C22.6944 9.7488 16.104 13.608 12.5088 19.7808H18.1872V23.5296H6V11.3424H9.7488V17.1072C11.4816 14.3856 13.752 12.0336 16.4496 10.1856C20.448 7.4448 25.1328 6 30 6C36.4128 6 42.4368 8.49601 46.9728 13.0272C51.504 17.5584 54 23.5872 54 30Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavShortForm);
export default __webpack_public_path__ + "static/media/favShortForm.77e14193.svg";
export { ForwardRef as ReactComponent };